var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeZoneSettings01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TimeZone Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.59,37.05H6.46v4.54H8.59a9.07,9.07,0,0,0,1.25,2.82L8.38,45.86,11,48.44,12.44,47a8.87,8.87,0,0,0,2.69,1.17v2.13h4.56V48.14a8.94,8.94,0,0,0,2.75-1.21l1.43,1.42,2.58-2.58L25,44.35a9.15,9.15,0,0,0,1.22-2.74h2.12V37H26.24a9.08,9.08,0,0,0-1.18-2.68L26.45,33l-2.58-2.58L22.5,31.74a9.17,9.17,0,0,0-2.8-1.24V28.37H15.12V30.5a9,9,0,0,0-2.74,1.21L11,30.29,8.38,32.87,9.8,34.29A8.89,8.89,0,0,0,8.59,37.05Zm5.07,2.27a3.76,3.76,0,1,1,3.75,3.75A3.75,3.75,0,0,1,13.66,39.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.94,27.81a23,23,0,1,1,23,23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "29.94 16.31 29.94 28.77 42.4 28.77"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeZoneSettings01);
export default __webpack_public_path__ + "static/media/TimeZone_Settings_01.e25f89006c669483e25a5044800f5e1c.svg";
export { ForwardRef as ReactComponent };